export const SET_CAPTCHA_RESPONSE = 'SET_CAPTCHA_RESPONSE';
export const HCAPTCHA_CN_API_HOST = 'https://cn1.hcaptcha.com';
export const HCAPTCHA_CN_ENDPOINT = 'https://cn1.hcaptcha.com';
export const HCAPTCHA_CN_ASSET_HOST = 'https://assets-cn1.hcaptcha.com';
export const HCAPTCHA_CN_IMG_HOST = 'https://imgs-cn1.hcaptcha.com';
export const HCAPTCHA_CN_REPORT_API = 'https://reportapi-cn1.hcaptcha.com';
export const HCAPTCHA_SITE_KEY_DEV = 'b41c74c9-25cf-4dec-ae85-77402d79b80a';
export const HCAPTCHA_SITE_KEY_STAGING = '16186854-de52-48e2-a25a-c9b493a28430';
export const HCAPTCHA_SITE_KEY_PROD = 'fddf32c4-33a4-4b18-912a-46fc0e82f753';
export const STAGING_ENVIRONMENTS_FOR_CAPTCHA = ['staging'];
export const PROD_ENVIRONMENTS_FOR_CAPTCHA = ['production'];
